import Http from '../../common/services/Http';
import { DeviceChecklistDto } from './models/DeviceChecklistDto';
import { DeviceFotaConfigDto } from './models/DeviceFotaConfigDto';
import { FotaLoginResponseDto } from './models/FotaLoginResponseDto';
import { FotaConfigFilesResponseDto } from './models/FotaConfigFilesResponseDto';
import { FotaAssignConfigurationResponseDto } from './models/FotaAssignConfigurationResponseDto';
import { FotaTaskStatusDto } from './models/FotaTaskStatusDto';
import { SendOdosetModel } from './models/SendOdosetModel';
import { SendSetparamVoltageModel } from './models/SendSetparamVoltageModel';
import { UpdateFuelTankModel } from './models/UpdateFuelTankModel';
import { TrackingItemDto } from './models/TrackingItemDto';
import { VoltageStatsDto } from './models/VoltageStatsDto';
import { Paged } from '../common/types/Page';

class DeviceChecklistService {
    public getChecklistData(licensePlate: string, date?: string) {
        return Http.get<DeviceChecklistDto>('devicechecklist', { licensePlate, date });
    }

    public getFotaConfig(imei: string, deviceModelName: string) {
        return Http.get<DeviceFotaConfigDto>('devicechecklist/fotaconfig', { imei, deviceModelName });
    }

    public fotaLogin(email: string, password: string) {
        return Http.post<FotaLoginResponseDto>('devicechecklist/fota/login', { email, password });
    }

    public fotaLoginTfa(otpCode: string, twoFactorAuthType: string) {
        return Http.post<FotaLoginResponseDto>('devicechecklist/fota/login-tfa', { otpCode, twoFactorAuthType });
    }

    public fotaStatus() {
        return Http.get<{ authenticated: boolean; email?: string }>('devicechecklist/fota/status');
    }

    public fotaLogout() {
        return Http.post<{ ok: boolean }>('devicechecklist/fota/logout', {});
    }

    public getFotaConfigFiles(deviceModelName: string) {
        return Http.get<FotaConfigFilesResponseDto>('devicechecklist/fota/configfiles', { deviceModelName });
    }

    public assignFotaConfig(imei: string, fileId: number) {
        return Http.post<FotaAssignConfigurationResponseDto>('devicechecklist/fota/assignconfig', { imei, fileId });
    }

    public sendWebConnect(deviceId: string) {
        return Http.post<{ ok: boolean; error?: string }>('devicechecklist/fota/sendwebconnect', { deviceId });
    }

    public sendSetParam(deviceId: string) {
        return Http.post<{ ok: boolean; error?: string }>('devicechecklist/fota/sendsetparam', { deviceId });
    }

    public getSmsStatus(iccid: string, content: string) {
        return Http.get<{ found: boolean }>('devicechecklist/fota/smsstatus', { iccid, content });
    }

    public getFotaTaskStatus(taskId: number) {
        return Http.get<FotaTaskStatusDto>(`devicechecklist/fota/taskstatus/${taskId}`);
    }

    public sendOdoset(model: SendOdosetModel) {
        return Http.post<string>('devicechecklist/sendodoset', model);
    }

    public sendSetparamVoltage(model: SendSetparamVoltageModel) {
        return Http.post<string>('devicechecklist/sendsetparamvoltage', model);
    }

    public sendGetParam(deviceId: string) {
        return Http.post<{ iccid: string }>('devicechecklist/sendgetparam', { deviceId });
    }

    public getParamResponse(iccid: string) {
        return Http.get<{ found: boolean; value: string | null }>('devicechecklist/getparamresponse', { iccid });
    }

    public updateFuelTank(model: UpdateFuelTankModel) {
        return Http.put<string>('devicechecklist/updatefueltank', model);
    }

    public getTrackingItems(vehicleId: string, startDate: string, stopDate?: string, page: number = 1, itemsPerPage: number = 16) {
        const params: Record<string, any> = { vehicleId, startDate, page, itemsPerPage };
        if (stopDate) params.stopDate = stopDate;
        return Http.get<Paged<TrackingItemDto>>('devicechecklist/trackingitems', params);
    }

    public getVoltageStats(deviceCode: string, startDate: string) {
        return Http.get<VoltageStatsDto>('devicechecklist/voltagestats', { deviceCode, startDate });
    }
}

export default new DeviceChecklistService();
